import { CanMatchFn, Routes } from '@angular/router';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { UserRole } from '../../auth/models/user-roles';
import { inject } from '@angular/core';
import { AuthService } from '../../auth/services/auth.service';

const canMatchRoles = (roles: UserRole[]): CanMatchFn => () => {
  const auth = inject(AuthService);
  return roles.some(role => auth.userHasRoleAndRoleIsEnabled(role));
};
const cardTemplateUserRoles = [
  UserRole.SuperUser
]

export const cardTemplateRoutes: Routes = [
  {
    path: 'card_templates',
    canLoad: [AutoLoginPartialRoutesGuard],
    canMatch: [canMatchRoles(cardTemplateUserRoles)],
    loadComponent: () =>
      import(
        './pages/card-templates-page.component'
      ).then((m) => m.CardTemplatesPageComponent),
  },
];
